import { useState } from "react";

export default function Avatar({
  user,
  size = "md",
  className = "",
  showFallback = true,
}) {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const sizeClasses = {
    sm: "avatar--sm",
    md: "avatar--md",
    lg: "avatar--lg",
    xl: "avatar--xl",
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  const shouldShowImage = user?.avatar && !imageError;
  const shouldShowFallback = showFallback && (!user?.avatar || imageError);

  return (
    <div className={`avatar ${sizeClasses[size]} ${className}`}>
      {shouldShowImage && (
        <img
          src={user.avatar}
          alt={user.name || "User avatar"}
          className="avatar__img"
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      )}

      {shouldShowFallback && (
        <span className="avatar__fallback">
          {user?.name?.charAt(0)?.toUpperCase() || "U"}
        </span>
      )}
    </div>
  );
}
